import { httpV2 } from "@/api";

/**
 * Consulta no back-end para obter uma lista de notificações (Alertas)
 * filtrada pela data de início, fim, elementos de monitoração (meIds) e status.
 * @param {Array<number>} meIds - Lista de IDs dos elementos de monitoração.
 * @param {string} startDateTime - Data/hora de início da consulta (UTC, ISO string).
 * @param {string} endDateTime - Data/hora de fim da consulta (UTC, ISO string).
 * @param {Array<string>} status - Lista de status a serem filtrados.
 * @returns {Promise} Lista de logs das notificações.
 */
const Get = function(meIds = [], startDateTime = "", endDateTime = "", status = [], managements = [])
{
	const payload = {
		MeIds:         meIds,
		StartDateTime: startDateTime,
		EndDateTime:   endDateTime,
		Status:        status,
		Managements:   managements
	};

	return httpV2.post("/notification-loggings", payload);
};

/**
 * Envia uma solicitação para atualizar os tratamentos de uma notificação específica.
 *
 * @param {number} [management=0] - O valor representando os tratamentos a serem atualizados.
 * @param {string|null} [expirationDate=null] - A data de expiração no formato ISO, ou null se não houver data.
 * @param {number} [loggingId=0] - O identificador da notificação que será atualizada.
 * @returns {Promise} Retorna a promessa da requisição HTTP do método POST para atualizar os tratamentos.
 */
const UpdateManagements = function(management = 0, expirationDate = null, loggingId = 0)
{
	const payload = {
		Management:       management,
		ExpirationInDays: expirationDate
	};

	return httpV2.post(`/notification-loggings/${loggingId}/managements`, payload);
};

/**
 * Obtém o arquivo de relatório anexado a um alarme.
 *
 * Faz uma requisição para baixar o arquivo de relatório associado à notificação
 * especificada pelo identificador e pelo ID do relatório.
 *
 * @param {Object} payload - Os dados necessários para download do arquivo.
 * @param {string} payload.notificationLoggingsId - O identificador da notificação.
 * @param {string} payload.id - O identificador do relatório a ser baixado.
 */
const DownloadReport = function(payload)
{
	return httpV2.get(`/notification-loggings/${payload.notificationLoggingsId}/report-files?reportId=${payload.id}`,
		{ responseType: "blob" });
};

/**
 * Faz o upload do arquivo de relatório anexado a um alarme.
 *
 * Constrói um FormData com o arquivo do relatório e envia para o endpoint
 * relacionado ao identificador da notificação especificada.
 *
 * @param {File} payload.reportFile - O arquivo do relatório a ser enviado.
 * @param {string} payload.loggindId - O identificador da notificação para anexar o relatório.
 */
const UploadReport = function(payload)
{
	const formData = new FormData();
	formData.append("file", payload.reportFile);

	return httpV2.post(`/notification-loggings/${payload.loggindId}/reports`, formData,
		{ headers: { "Content-Type": "multipart/form-data" } });
};

export default {
	Get,
	UpdateManagements,
	DownloadReport,
	UploadReport
};
